import { makeStyles } from '@mui/styles';
import { styles } from '@tcs/create-account/utils/theme';

export const useStyles = makeStyles({
  heading: {
    marginBottom: `${styles.spacing(6)}px`,
    fontFamily: styles.fonts.primary,
    fontSize: 40,
    fontWeight: 300,
    transition: styles.transitions.regular(['font-size']),
    [styles.breakpoints.down('md')]: {
      fontSize: 35,
    },
    [styles.breakpoints.down('sm')]: {
      fontSize: 30,
    },
  },
  headerGap: {
    height: 100,
  },
});
